import { Switch } from 'antd';
import styled from 'styled-components';

export const SSwitch: any = styled(Switch)`
  &[aria-checked='true'] {
    background-color: ${({ theme: { colors } }) => colors.primary};
  }
`;
